export interface IStorageService {
    length: number;
    key(index: number): string | null;
    setItem(key: string, item: unknown): void;
    getItem<TItemType>(key: string): TItemType | null;
    removeItem(key: string): void;
    clear(): void;
}
